module.exports = __webpack_public_path__ + "img/Wood.2c1c66ed.svg";